// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3BAIS","noInteraction":"EventWrapper_noInteraction__1Xnv3","pointerPassthrough":"EventWrapper_pointerPassthrough__wOrR9"};